import React from 'react';
import PropTypes from 'prop-types';

import { Typography } from '@material-ui/core';

import HTMLEntities from "../utils/HTMLEntities";
import Constants from "../utils/Constants";

function ActivityTitle(props) {
	// return null rather than empty typography component when no title
	let {title, twitterRedacted, color} = props;
	return title && (!twitterRedacted || twitterRedacted === Constants.ACTIVITY.TWITTER_REDACTION.SCRUB_GEO) ? (
		<Typography color={color} variant="h4">{HTMLEntities.decode(title)}</Typography>
	) : null;
}

ActivityTitle.propTypes = {
	title: PropTypes.string,
	color: PropTypes.string,
	twitterRedacted: PropTypes.string
};

export default ActivityTitle;